import { ROUTE_TEXT_MATERIALS_EDIT, ROUTE_TEXT_MATERIALS_MANAGEMENT } from '@@partner:config/routes'
import { useRedirectTo } from '@@partner:helpers/hooks/location'
import { GQL_ID } from '@@partner:types:graphql'
import TextMaterialForm from '@components/textMaterials/textMaterial/TextMaterialForm'
import React from 'react'
import { ArrowBackOutline } from 'react-ionicons'
import { generatePath, NavLink, useHistory, useParams } from 'react-router-dom'
import { Nav, Navbar } from 'rsuite'

export default function TextMaterialFormPage () {
  const { textId, brandSlug } = useParams<any>()
  const history = useHistory()

  const redirectToNewMaterial = (id: GQL_ID) => {
    const path = generatePath(ROUTE_TEXT_MATERIALS_EDIT, {
      brandSlug,
      textId: id
    })
    history.replace(path)
      
  }
  
  return (
    <div className="CustomerFormPage">
      <h1 className="u-heading">
        {textId ? 'Редактирование' : 'Добавление'} материала
      </h1>
      <Navbar appearance='subtle'>
        <Nav>
          <Nav.Item
            icon={<ArrowBackOutline />}
            as={NavLink}
            to={generatePath(ROUTE_TEXT_MATERIALS_MANAGEMENT, {
              brandSlug
            })}
          >
             Вернуться к списку
          </Nav.Item>
        </Nav>
      </Navbar>
      <TextMaterialForm 
        textId={textId} 
        brandSlug={brandSlug}
        onSaved={(id) => {
          if (!textId) {
            redirectToNewMaterial(id)
          }
        }}
      />
    </div>
  )
}